export default "__VITE_ASSET__0441bb08__"